<template>
  <div class="page-container">
    <v-container fluid class="pa-5 pt-5">
      <!-- Header Section -->
      <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        type="table-heading"
      >
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{
            $t("_ProductDetail")
          }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <!-- <v-chip
              class="date-chip"
              variant="outlined"
              prepend-icon="mdi-calendar"
            >
              
            </v-chip> -->
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>

      <!-- Main Content -->
      <div class="content-wrapper">
        <!-- Product Group Section -->
        <v-card class="modern-card group-card" elevation="0">
          <div class="card-header">
            <v-icon class="header-icon" color="primary"
              >mdi-folder-multiple</v-icon
            >
            <span class="card-title">Product Group Information</span>
          </div>
          <v-card-text class="card-content">
            <div class="d-flex align-start" style="gap: 16px;">
              <v-text-field
                id="ProductGroupName-productdetail"
                v-model="productGroup.productGroupName"
                label="Product Group Name"
                variant="outlined"
                density="compact"
                prepend-inner-icon="mdi-tag"
                :rules="[rules.required]"
                :error-messages="
                  !productGroup.productGroupName && productGroupNameTouched
                    ? 'Product Group Name is required'
                    : ''
                "
                @blur="productGroupNameTouched = true"
                class="minimal-field flex-grow-1"
                hide-details="auto"
              ></v-text-field>
              <v-btn
                v-if="!isViewOnly"
                id="UpdateProductGroup-productdetail"
                class="modern-btn"
                color="primary"
                variant="elevated"
                height="41"
                :disabled="isUpdateGroupBtnDisabled"
                prepend-icon="mdi-content-save"
                @click="updateProductGroup"
              >
                Update
              </v-btn>
            </div>
          </v-card-text>
        </v-card>

        <!-- Products Section -->
        <v-card class="modern-card products-card" elevation="0">
          <!-- Products Header -->
          <div class="products-header">
            <div class="products-header-left">
              <v-icon class="header-icon" color="primary"
                >mdi-cube-outline</v-icon
              >
              <span class="card-title">Products</span>
              <v-chip
                v-if="products.length > 0"
                class="ml-3"
                size="small"
                color="primary"
                variant="tonal"
              >
                {{ products.length }}
                {{ products.length === 1 ? "product" : "products" }}
              </v-chip>
            </div>
            <div class="products-header-right">
              <v-btn
                v-if="canEdit"
                id="button-reprocess-productdetail"
                class="modern-btn reprocess-btn"
                variant="elevated"
                @click="ReprocessVectorProduct"
                :disabled="
                  !productGroup.productGroupID || products.length === 0
                "
                prepend-icon="mdi-refresh"
              >
                Reprocess
                <span v-if="needsReprocessing" class="notification-badge"
                  >!</span
                >
              </v-btn>
              <v-btn
                v-if="canEdit"
                id="ManageCategories-productdetail"
                class="modern-btn"
                color="secondary"
                variant="outlined"
                @click="openCategoryDialog"
                :disabled="!productGroup.productGroupName"
                prepend-icon="mdi-tag-multiple"
              >
                Categories
              </v-btn>
              <v-btn
                v-if="canAdd"
                id="AddProduct-productdetail"
                class="modern-btn"
                color="primary"
                variant="elevated"
                @click="validateBeforeAddProduct"
                :disabled="!productGroup.productGroupName"
                prepend-icon="mdi-plus"
              >
                Add Product
              </v-btn>
            </div>
          </div>

          <!-- Search and Filter Section -->
          <v-card-text class="search-section">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  id="field-searchProductName-productdetail"
                  v-model="searchProductName"
                  label="Search products..."
                  variant="outlined"
                  density="comfortable"
                  clearable
                  prepend-inner-icon="mdi-magnify"
                  @input="filterProducts"
                  class="modern-search"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  id="filterProducts-productdetail"
                  v-model="searchCategory"
                  :items="[
                    {
                      productCategoryName: 'All Categories',
                      productCategoryID: null,
                    },
                    ...filterCategoryOptions,
                  ]"
                  item-title="productCategoryName"
                  item-value="productCategoryID"
                  label="Filter by category"
                  variant="outlined"
                  density="comfortable"
                  prepend-inner-icon="mdi-filter-variant"
                  @update:model-value="filterProducts"
                  class="modern-select"
                ></v-select>
              </v-col>
            </v-row>

            <!-- Filter Results Info -->
            <div
              v-if="searchProductName || searchCategory !== undefined"
              class="filter-info"
            >
              <v-chip
                class="result-chip"
                color="info"
                variant="tonal"
                prepend-icon="mdi-information"
              >
                {{ filteredProducts.length }} result{{
                  filteredProducts.length !== 1 ? "s" : ""
                }}
              </v-chip>
              <v-btn
                id="button-clearfilters-productdetail"
                size="small"
                variant="text"
                color="primary"
                @click="clearFilters"
                prepend-icon="mdi-filter-remove"
                class="clear-filter-btn"
              >
                Clear filters
              </v-btn>
            </div>
          </v-card-text>

          <!-- Product Cards -->
          <v-card-text class="products-grid">
            <div
              v-if="filteredProducts.length === 0 && products.length === 0"
              class="empty-state"
            >
              <v-icon size="48" color="grey lighten-1"
                >mdi-package-variant-closed</v-icon
              >
              <h3 class="empty-title">No products yet</h3>
              <p class="empty-subtitle">
                Add your first product to get started
              </p>
            </div>
            <div
              v-else-if="
                filteredProducts.length === 0 &&
                (searchProductName || searchCategory !== null)
              "
              class="empty-state"
            >
              <v-icon size="48" color="grey lighten-1">mdi-magnify</v-icon>
              <h3 class="empty-title">No results found</h3>
              <p class="empty-subtitle">Try adjusting your search or filters</p>
            </div>
            <div v-else class="products-list">
              <v-card
                v-for="(product, index) in filteredProducts"
                :key="index"
                class="product-card-modern"
                elevation="1"
                hover
              >
                <div class="product-layout">
                  <!-- Product Image - ลดขนาด -->
                  <div class="product-image-container">
                    <v-img
                      :src="
                        product.productImg
                          ? product.productImg
                          : '/img/no-image.png'
                      "
                      height="120"
                      cover
                      class="product-image-modern"
                    >
                      <template v-slot:placeholder>
                        <div class="image-placeholder">
                          <v-icon size="32" color="grey lighten-2"
                            >mdi-image</v-icon
                          >
                        </div>
                      </template>
                    </v-img>
                  </div>

                  <!-- Product Content - ลด padding และ gap -->
                  <div class="product-content">
                    <!-- Product Header - ปรับให้กระชับ -->
                    <div class="product-header-info">
                      <h4 class="product-name">{{ product.productName }}</h4>
                      <div class="product-price">
                        {{
                          product.productPrice
                            ? `฿${product.productPrice.toLocaleString()}`
                            : "No price"
                        }}
                      </div>
                    </div>

                    <!-- Product Category - ลดขนาด chip -->
                    <div class="product-category">
                      <v-chip
                        size="small"
                        density="compact"
                        :color="
                          product.productCategoryID === null
                            ? 'grey'
                            : 'primary'
                        "
                        variant="tonal"
                        prepend-icon="mdi-tag"
                      >
                        {{ getCategoryName(product.productCategoryID) }}
                      </v-chip>
                    </div>

                    <!-- Language Indicators -->
                    <div class="language-indicators" v-if="product.productNameCN || product.productNameEN">
                      <v-chip
                        v-if="product.productNameCN"
                        size="x-small"
                        density="compact"
                        color="orange"
                        variant="tonal"
                        class="lang-chip"
                      >
                        中文
                      </v-chip>
                      <v-chip
                        v-if="product.productNameEN"
                        size="x-small"
                        density="compact"
                        color="blue"
                        variant="tonal"
                        class="lang-chip"
                      >
                        EN
                      </v-chip>
                    </div>

                    <!-- Product Description - ลดขนาดฟอนต์และ line clamp -->
                    <p class="product-description-modern">
                      {{ product.productDetail }}
                    </p>

                    <!-- Product Status - ใช้ chip ขนาดเล็ก -->
                    <div class="product-status">
                      <v-chip
                        size="small"
                        density="compact"
                        :color="product.isRecommend ? 'success' : 'grey'"
                        variant="tonal"
                        class="status-chip"
                      >
                        <v-icon start size="12">{{
                          product.isRecommend
                            ? "mdi-thumb-up"
                            : "mdi-thumb-up-outline"
                        }}</v-icon>
                        {{ product.isRecommend ? "Rec" : "Not Rec" }}
                      </v-chip>
                      <v-chip
                        size="small"
                        density="compact"
                        :color="product.isActive ? 'info' : 'grey'"
                        variant="tonal"
                        class="status-chip"
                      >
                        <v-icon start size="12">{{
                          product.isActive ? "mdi-eye" : "mdi-eye-off"
                        }}</v-icon>
                        {{ product.isActive ? "Visible" : "Hidden" }}
                      </v-chip>
                    </div>

                    <!-- Product Actions - ใช้ปุ่มขนาดเล็ก -->
                    <div class="product-actions">
                      <v-btn
                        :id='"button-editproduct-productdetail"'
                        variant="outlined"
                        color="primary"
                        size="small"
                        @click="editProduct(index)"
                        :prepend-icon="canEdit ? 'mdi-pencil' : 'mdi-eye-outline'"
                        class="action-btn"
                      >
                        {{ canEdit ? 'Edit' : 'View' }}
                      </v-btn>
                      <v-btn
                        v-if="canDelete"
                        :id='"button-deleteproduct-productdetail"'
                        variant="outlined"
                        color="error"
                        size="small"
                        @click="deleteProduct(product.productID, index)"
                        prepend-icon="mdi-delete"
                        class="action-btn delet-btn"
                        :disabled="btnDisableDelete(product)"
                      >
                        Delete
                      </v-btn>
                    </div>
                  </div>
                </div>
              </v-card>
            </div>
          </v-card-text>
        </v-card>
      </div>

      <!-- Product Dialog -->
      <v-dialog v-model="productDialog" max-width="800px" class="modern-dialog">
        <v-card class="dialog-card" elevation="8">
          <div class="dialog-header dialog-header-add">
            <div class="header-main">
              <div class="header-icon-container">
                <div class="icon-background">
                  <v-icon color="white">
                    {{ editingIndex > -1 ? "mdi-pencil" : "mdi-plus" }}
                  </v-icon>
                </div>
              </div>
              <div class="header-text-content">
                <div class="dialog-title">
                  {{ editingIndex > -1 ? (canEdit ? "Edit Product" : "View Product") : "Add New Product" }}
                </div>
              </div>
            </div>
            <div class="header-actions">
              <v-btn
                icon
                variant="text"
                @click="closeProductDialog"
                class="close-button"
                color="white"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>

          <v-card-text class="dialog-content">

            <!-- Language Tabs -->
            <v-tabs v-model="currentLanguageTab" bg-color="transparent" color="primary" class="language-tabs mb-4">
              <v-tab :value="0" class="language-tab">
                <span class="flag-emoji">TH</span>
                ภาษาไทย (Default)
              </v-tab>
              <v-tab :value="1" class="language-tab">
                <span class="flag-emoji">CN</span>
                中文 (Chinese)
              </v-tab>
              <v-tab :value="2" class="language-tab">
                <span class="flag-emoji">EN</span>
                English
              </v-tab>
            </v-tabs>

            <v-form>
              <v-window v-model="currentLanguageTab">
                <!-- Thai Tab -->
                <v-window-item :value="0">
                  <v-row>
                    <!-- Product Name -->
                    <v-col cols="12" md="12">
                      <v-text-field
                        id="productName-productdialog-productdetail"
                        v-model="currentProduct.productName"
                        label="Product Name (Thai)"
                        variant="outlined"
                        density="comfortable"
                        :rules="[rules.required]"
                        prepend-inner-icon="mdi-package-variant"
                        class="modern-input"
                      ></v-text-field>
                    </v-col>

                    <!-- Product Image Upload -->
                    <v-col cols="12" md="12">
                      <div class="image-upload-modern">
                        <v-btn
                          id="imageUpload-productdialog-productdetail"
                          variant="outlined"
                          color="primary"
                          block
                          height="56"
                          @click="$refs.fileInput.click()"
                          class="upload-btn-modern"
                          prepend-icon="mdi-camera"
                        >
                          {{ productImage ? "Change Image (Thai)" : "Upload Image (Thai)" }}
                        </v-btn>

                        <input
                          id="fileInput-productdialog-productdetail"
                          ref="fileInput"
                          type="file"
                          accept="image/*"
                          style="display: none"
                          @change="handleImageUpload($event.target.files[0], 'th')"
                        />

                        <div v-if="productImage" class="selected-file-modern">
                          <v-icon class="mr-2" color="success"
                            >mdi-check-circle</v-icon
                          >
                          <span class="file-name">{{ productImage.name }}</span>
                          <v-btn
                            icon
                            size="small"
                            variant="text"
                            color="error"
                            @click="clearImage('th')"
                            class="ml-2"
                          >
                            <v-icon size="18">mdi-close</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </v-col>

                    <!-- Product Detail -->
                    <v-col cols="12">
                      <v-textarea
                        id="textarea-productdialog-productdetail"
                        v-model="currentProduct.productDetail"
                        label="Product Details (Thai)"
                        :rules="[rules.required]"
                        variant="outlined"
                        auto-grow
                        rows="4"
                        counter
                        prepend-inner-icon="mdi-text"
                        class="modern-textarea"
                      ></v-textarea>
                    </v-col>

                    <!-- Image Preview -->
                    <v-col cols="12" v-if="imagePreview">
                      <div class="image-preview-container">
                        <h4 class="preview-title">Image Preview (Thai)</h4>
                        <v-card class="preview-card" elevation="2">
                          <v-img
                            :src="imagePreview"
                            max-height="300"
                            contain
                            class="preview-image"
                          ></v-img>
                        </v-card>
                      </div>
                    </v-col>
                  </v-row>
                </v-window-item>

                <!-- Chinese Tab -->
                <v-window-item :value="1">
                  <v-row>
                    <!-- Product Name CN -->
                    <v-col cols="12" md="12">
                      <v-text-field
                        id="productNameCN-productdialog-productdetail"
                        v-model="currentProduct.productNameCN"
                        label="Product Name (Chinese)"
                        variant="outlined"
                        density="comfortable"
                        prepend-inner-icon="mdi-package-variant"
                        class="modern-input"
                        hint="Optional"
                        persistent-hint
                      ></v-text-field>
                    </v-col>

                    <!-- Product Image Upload CN -->
                    <v-col cols="12" md="12">
                      <div class="image-upload-modern">
                        <v-btn
                          id="imageUploadCN-productdialog-productdetail"
                          variant="outlined"
                          color="primary"
                          block
                          height="56"
                          @click="$refs.fileInputCN.click()"
                          class="upload-btn-modern"
                          prepend-icon="mdi-camera"
                        >
                          {{ productImageCN ? "Change Image (Chinese)" : "Upload Image (Chinese)" }}
                        </v-btn>

                        <input
                          id="fileInputCN-productdialog-productdetail"
                          ref="fileInputCN"
                          type="file"
                          accept="image/*"
                          style="display: none"
                          @change="handleImageUpload($event.target.files[0], 'cn')"
                        />

                        <div v-if="productImageCN" class="selected-file-modern">
                          <v-icon class="mr-2" color="success"
                            >mdi-check-circle</v-icon
                          >
                          <span class="file-name">{{ productImageCN.name }}</span>
                          <v-btn
                            icon
                            size="small"
                            variant="text"
                            color="error"
                            @click="clearImage('cn')"
                            class="ml-2"
                          >
                            <v-icon size="18">mdi-close</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </v-col>

                    <!-- Product Detail CN -->
                    <v-col cols="12">
                      <v-textarea
                        id="textareaCN-productdialog-productdetail"
                        v-model="currentProduct.productDetailCN"
                        label="Product Details (Chinese)"
                        variant="outlined"
                        auto-grow
                        rows="4"
                        counter
                        prepend-inner-icon="mdi-text"
                        class="modern-textarea"
                        hint="Optional"
                        persistent-hint
                      ></v-textarea>
                    </v-col>

                    <!-- Image Preview CN -->
                    <v-col cols="12" v-if="imagePreviewCN">
                      <div class="image-preview-container">
                        <h4 class="preview-title">Image Preview (Chinese)</h4>
                        <v-card class="preview-card" elevation="2">
                          <v-img
                            :src="imagePreviewCN"
                            max-height="300"
                            contain
                            class="preview-image"
                          ></v-img>
                        </v-card>
                      </div>
                    </v-col>
                  </v-row>
                </v-window-item>

                <!-- English Tab -->
                <v-window-item :value="2">
                  <v-row>
                    <!-- Product Name EN -->
                    <v-col cols="12" md="12">
                      <v-text-field
                        id="productNameEN-productdialog-productdetail"
                        v-model="currentProduct.productNameEN"
                        label="Product Name (English)"
                        variant="outlined"
                        density="comfortable"
                        prepend-inner-icon="mdi-package-variant"
                        class="modern-input"
                        hint="Optional"
                        persistent-hint
                      ></v-text-field>
                    </v-col>

                    <!-- Product Image Upload EN -->
                    <v-col cols="12" md="12">
                      <div class="image-upload-modern">
                        <v-btn
                          id="imageUploadEN-productdialog-productdetail"
                          variant="outlined"
                          color="primary"
                          block
                          height="56"
                          @click="$refs.fileInputEN.click()"
                          class="upload-btn-modern"
                          prepend-icon="mdi-camera"
                        >
                          {{ productImageEN ? "Change Image (English)" : "Upload Image (English)" }}
                        </v-btn>

                        <input
                          id="fileInputEN-productdialog-productdetail"
                          ref="fileInputEN"
                          type="file"
                          accept="image/*"
                          style="display: none"
                          @change="handleImageUpload($event.target.files[0], 'en')"
                        />

                        <div v-if="productImageEN" class="selected-file-modern">
                          <v-icon class="mr-2" color="success"
                            >mdi-check-circle</v-icon
                          >
                          <span class="file-name">{{ productImageEN.name }}</span>
                          <v-btn
                            icon
                            size="small"
                            variant="text"
                            color="error"
                            @click="clearImage('en')"
                            class="ml-2"
                          >
                            <v-icon size="18">mdi-close</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </v-col>

                    <!-- Product Detail EN -->
                    <v-col cols="12">
                      <v-textarea
                        id="textareaEN-productdialog-productdetail"
                        v-model="currentProduct.productDetailEN"
                        label="Product Details (English)"
                        variant="outlined"
                        auto-grow
                        rows="4"
                        counter
                        prepend-inner-icon="mdi-text"
                        class="modern-textarea"
                        hint="Optional"
                        persistent-hint
                      ></v-textarea>
                    </v-col>

                    <!-- Image Preview EN -->
                    <v-col cols="12" v-if="imagePreviewEN">
                      <div class="image-preview-container">
                        <h4 class="preview-title">Image Preview (English)</h4>
                        <v-card class="preview-card" elevation="2">
                          <v-img
                            :src="imagePreviewEN"
                            max-height="300"
                            contain
                            class="preview-image"
                          ></v-img>
                        </v-card>
                      </div>
                    </v-col>
                  </v-row>
                </v-window-item>
              </v-window>
            </v-form>
            <!-- Divider -->
            <v-divider class="my-4"></v-divider>
            <v-row class="mb-4">
              <!-- Product Price -->
              <v-col cols="12" md="6">
                <v-text-field
                  id="productprice-productdialog-productdetail"
                  v-model="currentProduct.productPrice"
                  label="Price"
                  variant="outlined"
                  density="comfortable"
                  prefix="฿"
                  type="number"
                  step="0.01"
                  min="0"
                  @input="formatProductPrice"
                  @keydown="preventInvalidPriceInput"
                  prepend-inner-icon="mdi-currency-usd"
                  class="modern-input"
                ></v-text-field>
              </v-col>

              <!-- Product Category -->
              <v-col cols="12" md="6">
                <v-select
                  id="productCategory-productdialog-productdetail"
                  v-model="currentProduct.productCategoryID"
                  :items="categoryOptions"
                  item-title="productCategoryName"
                  item-value="productCategoryID"
                  label="Category (Optional)"
                  variant="outlined"
                  density="comfortable"
                  prepend-inner-icon="mdi-tag"
                  class="modern-select"
                ></v-select>
              </v-col>

              <!-- Recommend Switch -->
              <v-col cols="12" md="6">
                <div class="switches-container">
                  <v-switch
                    id="switchRecommend-productdialog-productdetail"
                    v-model="currentProduct.isRecommend"
                    label="Recommend this product"
                    color="success"
                    density="comfortable"
                    class="modern-switch"
                    inset
                  ></v-switch>
                </div>
              </v-col>

              <!-- Active/Visible Switch -->
              <v-col cols="12" md="6">
                <div class="switches-container">
                  <v-switch
                    id="switchIsActice-productdialog-productdetail"
                    v-model="currentProduct.isActive"
                    :label='currentProduct.isActive ? "Visible" : "Hidden"'
                    color="primary"
                    density="comfortable"
                    class="modern-switch"
                    inset
                  ></v-switch>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions class="dialog-actions">
            <div class="actions-content">
              <div class="actions-left"></div>
              <div class="actions-right">
                <v-btn
                  variant="outlined"
                  color="grey"
                  @click="closeProductDialog"
                  class="dialog-action-btn cancel-btn"
                >
                  Cancel
                </v-btn>
                <v-btn
                  v-if="editingIndex > -1 ? canEdit : canAdd"
                  variant="elevated"
                  @click="saveProduct(currentProduct)"
                  :disabled="!isProductFormValid"
                  class="dialog-action-btn save-btn-add"
                >
                  {{ editingIndex > -1 ? "Update" : "Save" }}
                </v-btn>
              </div>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Category Management Dialog -->
      <v-dialog
        v-model="categoryDialog"
        max-width="700px"
        class="modern-dialog"
        @click:outside="ClickCategoryDialogOutside"
      >
        <v-card class="dialog-card" elevation="8">
          <div class="dialog-header dialog-header-add">
            <div class="header-main">
              <div class="header-icon-container">
                <div class="icon-background">
                  <v-icon color="white">mdi-tag-multiple</v-icon>
                </div>
              </div>
              <div class="header-text-content">
                <h2 class="dialog-title">Category Management</h2>
              </div>
            </div>
            <div class="header-actions">
              <v-btn
                icon
                variant="text"
                @click="closeCategoryDialog"
                class="close-button"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </div>
            <!-- <h2 class="dialog-title">
              Category Management
            </h2> -->
          </div>

          <v-card-text class="dialog-content">
            <!-- Add New Category -->
            <div class="add-category-section">
              <v-text-field
                id="CategoryName-CategoryManagementDialog-productdetail"
                v-model="newCategory"
                label="Category Name"
                variant="outlined"
                density="comfortable"
                append-inner-icon="mdi-plus"
                @click:append-inner="addCategory"
                @keyup.enter="addCategory"
                prepend-inner-icon="mdi-tag"
                class="modern-input"
              ></v-text-field>
            </div>

            <v-divider class="my-6"></v-divider>

            <!-- Categories List -->
            <div class="categories-section">
              <h3 class="section-title">
                <v-icon class="mr-2">mdi-format-list-bulleted</v-icon>
                Current Categories
              </h3>

              <div v-if="categories.length === 0" class="empty-categories">
                <v-icon size="48" color="grey lighten-2">mdi-tag-off</v-icon>
                <p class="empty-text">No categories added yet</p>
                <p class="empty-subtext">Add your first category above</p>
              </div>

              <div v-else class="categories-list">
                <v-card
                  v-for="(category, index) in categories"
                  :key="index"
                  class="category-item"
                  elevation="1"
                >
                  <div class="category-content">
                    <div class="category-info">
                      <v-icon class="category-icon" color="primary"
                        >mdi-tag</v-icon
                      >
                      <v-text-field
                        :id='"edit-CategoryName-CategoryManagementDialog-productdetail-" + index'
                        v-if="editingCategoryIndex === index"
                        v-model="editedCategoryName"
                        density="compact"
                        variant="outlined"
                        hide-details
                        autofocus
                        @keyup.enter="saveEditedCategory"
                        class="edit-input"
                      ></v-text-field>
                      <span v-else class="category-name">{{
                        category.productCategoryName
                      }}</span>
                    </div>
                    <div class="category-actions">
                      <v-btn
                        :id='"button-edit-CategoryManagementDialog-productdetail-" + index'
                        v-if="editingCategoryIndex !== index"
                        icon
                        size="small"
                        variant="text"
                        color="primary"
                        @click="startEditCategory(index)"
                      >
                        <v-icon size="18">mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn
                        :id='"button-confirmEdit-CategoryManagementDialog-productdetail-" + index'
                        v-else
                        icon
                        size="small"
                        variant="text"
                        color="success"
                        @click="saveEditedCategory"
                      >
                        <v-icon size="18">mdi-check</v-icon>
                      </v-btn>
                      <v-btn
                        :id='"button-remove-CategoryManagementDialog-productdetail-" + index'
                        icon
                        size="small"
                        variant="text"
                        color="error"
                        @click="removeCategory(index)"
                      >
                        <v-icon size="18">mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-card>
              </div>
            </div>
          </v-card-text>

          <v-card-actions class="dialog-actions">
            <div class="actions-content">
              <div class="actions-left"></div>
              <div class="actions-right">
                <v-btn
                  variant="outlined"
                  color="grey"
                  @click="closeCategoryDialog"
                  class="dialog-action-btn cancel-btn"
                >
                  Close
                </v-btn>
                <v-btn
                  v-if="canEdit"
                  variant="elevated"
                  @click="saveCategory"
                  :disabled="!isCategoryChanged"
                  class="dialog-action-btn save-btn-add"
                >
                
                  Save Changes
                </v-btn>
              </div>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <!-- Loading Overlay -->
    <v-overlay :model-value="dialog" class="align-center justify-center">
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>
<script>
import checkPermissionTwo from "@/api/function.js";
export default {
  name: "ProductDetail",
  mixins: [checkPermissionTwo],
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround","Username" , "RoleId"],
  data: () => ({
    id: null,
    today: null,
    uploadedFiles: [],
    entity: null,
    dialog: false,
    searchProductName: "",
    searchCategory: null,
    filteredProductsList: [],
    productGroup: {
      productGroupID: null,
      productGroupName: "",
    },
    originalProductGroupName: "",

    // Categories
    newCategory: "",
    categories: [],
    nextCategoryId: 1,
    originalCategories: [], // เก็บ categories ต้นฉบับไว้เปรียบเทียบ

    // Products
    products: [],
    currentProduct: {
      productID: 0,
      productGroupID: 0,
      productCategoryID: null,
      productName: "",
      productImg: "",
      productDetail: "",
      productPrice: null,
      isRecommend: false,
      isActive: true,
      // Chinese fields
      productNameCN: "",
      productImgCN: "",
      productDetailCN: "",
      // English fields
      productNameEN: "",
      productImgEN: "",
      productDetailEN: "",
    },
    nextProductId: 1,
    productDialog: false,
    editingIndex: -1,
    deleteIndex: -1,

    // Image handling
    productImage: null,
    imagePreview: null,
    productImageCN: null,
    imagePreviewCN: null,
    productImageEN: null,
    imagePreviewEN: null,
    
    // Language tab
    currentLanguageTab: 0,

    // Validation
    rules: {
      required: (value) => !!value || "Required field",
      positiveNumber: (value) =>
        value === null ||
        value === "" ||
        parseFloat(value) >= 0 ||
        "Price must be positive",
      maxTwoDecimals: (value) => {
        if (value === null || value === "") return true;
        const regex = /^\d+(\.\d{0,2})?$/;
        return (
          regex.test(value.toString()) || "Maximum 2 decimal places allowed"
        );
      },
    },
    // Add this property to your existing data
    categoryDialog: false,

    // Add isSaving to track save state
    productGroupNameTouched: false,

    // Add these properties to your existing data
    editingCategoryIndex: -1,
    editedCategoryName: "",

    needsReprocessing: false,
  }),
  computed: {
    isUpdateGroupBtnDisabled() {
      return !this.productGroup.productGroupName || 
             !this.productGroup.productGroupName.trim() || 
             this.productGroup.productGroupName === this.originalProductGroupName;
    },
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('ProductDetail');
    },
    canAdd() {
      return !!(this.$pagePermission && this.$pagePermission.canAdd('ProductDetail'));
    },
    canEdit() {
      return !!(this.$pagePermission && this.$pagePermission.canEdit('ProductDetail'));
    },
    canDelete() {
      return !!(this.$pagePermission && this.$pagePermission.canDelete('ProductDetail'));
    },
    filteredProducts() {
      return this.searchProductName || this.searchCategory !== null
        ? this.filteredProductsList
        : this.products;
    },
    isProductFormValid() {
      return this.currentProduct.productName;
    },
    filterCategoryOptions() {
      let self = this;
      return [
        ...self.categories.map((cat) => ({
          productCategoryName: cat.productCategoryName,
          productCategoryID: cat.productCategoryID,
          activeFlag: cat.activeFlag,
        })),
      ];
    },
    categoryOptions() {
      let self = this;
      return [
        {
          productCategoryName: "No Category",
          productCategoryID: 0,
          activeFlag: true,
        },
        ...self.categories.map((cat) => ({
          productCategoryName: cat.productCategoryName,
          productCategoryID: cat.productCategoryID,
          activeFlag: cat.activeFlag,
        })),
      ];
    },
    isCategoryChanged() {
      // ถ้า categories และ originalCategories มีความยาวไม่เท่ากัน แสดงว่ามีการเพิ่มหรือลบ
      if (this.categories.length !== this.originalCategories.length) {
        return true;
      }

      // ตรวจสอบว่ามีการเปลี่ยนแปลงชื่อหรือไม่
      for (let i = 0; i < this.categories.length; i++) {
        const current = this.categories[i];
        const original = this.originalCategories.find(
          (cat) => cat.productCategoryID === current.productCategoryID
        );

        // ถ้าไม่พบ category หรือชื่อไม่ตรงกัน แสดงว่ามีการเปลี่ยนแปลง
        if (
          !original ||
          current.productCategoryName !== original.productCategoryName
        ) {
          return true;
        }
      }

      return false;
    },
  },
  watch: {},
  methods: {
    btnDisableDelete(item) {
      if (this.RoleId == 2 && item.createBy != this.Username) {
        return true;
      }
      return false;
    },
    ClickCategoryDialogOutside() {
      this.newCategory = "";
      this.categories = this.categories.filter(item => item.productCategoryID !== null);
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    updateProductGroup() {
      let self = this;
      self.dialog = true;
      
      const payload = {
        productGroupID: this.productGroup.productGroupID,
        productGroupName: this.productGroup.productGroupName,
      };
      
      this.$call.UpdateProductGroup(
        payload,
        (dataResponse) => {
          self.dialog = false;
          if (dataResponse.status === 0 || dataResponse.status === 200) {
            self.showSuccessMessage("Product Group Name updated successfully");
            self.originalProductGroupName = self.productGroup.productGroupName;
          } else {
            self.$swal.fire({
              icon: "error",
              title: dataResponse.message || "Failed to update Product Group Name",
              showConfirmButton: true,
              confirmButtonText: self.$t("gotIt"),
              confirmButtonColor: "#d33",
            });
          }
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
          self.$swal.fire({
            icon: "error",
            title: "An error occurred while updating the product group name",
            showConfirmButton: true,
            confirmButtonText: self.$t("gotIt"),
            confirmButtonColor: "#d33",
          });
        }
      );
    },
    validateBeforeAddProduct() {
      if (
        !this.productGroup.productGroupName ||
        this.productGroup.productGroupName.trim() === ""
      ) {
        this.$swal.fire({
          icon: "warning",
          title: "Product Group Name Required",
          text: "Please enter a Product Group Name before adding products.",
          confirmButtonColor: "#3085d6",
        });
        return;
      }

      // If validation passes, open the product dialog
      this.openProductDialog();
    },
    // Category methods
    addCategory() {
      // ตรวจสอบว่ามีข้อความหรือไม่
      if (!this.newCategory || this.newCategory.trim() === "") return;

      // ตรวจสอบว่ามีชื่อซ้ำกันหรือไม่ (ไม่คำนึงถึงตัวพิมพ์ใหญ่-เล็ก)
      const categoryNameLower = this.newCategory.trim().toLowerCase();
      const isDuplicate = this.categories.some(
        (cat) => cat.productCategoryName.toLowerCase() === categoryNameLower
      );

      // ถ้ามีชื่อซ้ำ ให้แสดง alert และไม่เพิ่มข้อมูล
      if (isDuplicate) {
        this.$swal.fire({
          icon: "warning",
          title: "Duplicate Category",
          text: `Category "${this.newCategory}" already exists.`,
          confirmButtonColor: "#3085d6",
        });
        return;
      }

      // ถ้าไม่ซ้ำ ค่อยเพิ่มข้อมูล
      this.categories.push({
        productCategoryID: null,
        productCategoryName: this.newCategory.trim(),
        activeFlag: true,
      });

      this.newCategory = "";

      // If a search filter is active, update results
      if (this.searchProductName || this.searchCategory !== null) {
        this.filterProducts();
      }
    },

    removeCategory(index) {
      // Check if category is in use before removing
      const categoryId = this.categories[index].productCategoryID;
      const inUse = this.products.some(
        (product) => product.productCategoryID === categoryId
      );

      if (inUse) {
        this.$swal.fire({
          icon: "warning",
          title: "Cannot Remove Category",
          text: "This category is being used by one or more products.",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
        });
        return;
      }

      this.categories.splice(index, 1);
    },

    getCategoryName(categoryId) {
      if (categoryId === null) {
        return "No Category";
      }
      const category = this.categories.find(
        (cat) => cat.productCategoryID === categoryId
      );
      return category ? category.productCategoryName : "No Category";
    },

    // Add these methods to your existing methods
    startEditCategory(index) {
      this.editingCategoryIndex = index;
      this.editedCategoryName = this.categories[index].productCategoryName;
    },

    // แก้ไขเมธอด saveEditedCategory() ให้ทำงานเมื่อกดปุ่มยืนยัน และตรวจสอบชื่อซ้ำ
    saveEditedCategory() {
      if (this.editingCategoryIndex === -1) return;

      // ตรวจสอบว่าชื่อไม่ว่างเปล่า
      if (!this.editedCategoryName || this.editedCategoryName.trim() === "") {
        this.$swal.fire({
          icon: "warning",
          title: "Category Name Required",
          text: "Category name cannot be empty.",
          confirmButtonColor: "#3085d6",
        });
        return;
      }

      // ตรวจสอบการซ้ำกันของชื่อ category (ไม่รวมตัวเอง)
      const categoryNameLower = this.editedCategoryName.trim().toLowerCase();
      const isDuplicate = this.categories.some(
        (cat, idx) =>
          idx !== this.editingCategoryIndex &&
          cat.productCategoryName.toLowerCase() === categoryNameLower
      );

      if (isDuplicate) {
        this.$swal.fire({
          icon: "warning",
          title: "Duplicate Category",
          text: `Category "${this.editedCategoryName}" already exists.`,
          confirmButtonColor: "#3085d6",
        });
        return;
      }

      // บันทึกการเปลี่ยนแปลง
      this.categories[this.editingCategoryIndex].productCategoryName =
        this.editedCategoryName.trim();

      // ออกจากโหมดแก้ไข
      this.editingCategoryIndex = -1;
      this.editedCategoryName = "";

      // ถ้ามีการใช้ filter อยู่ ให้อัปเดตผลลัพธ์
      if (this.searchProductName || this.searchCategory !== null) {
        this.filterProducts();
      }
    },

    cancelEditCategory() {
      this.editingCategoryIndex = -1;
      this.editedCategoryName = "";
    },

    // Product methods
    openProductDialog() {
      this.editingIndex = -1;
      this.currentLanguageTab = 0;
      this.currentProduct = {
        productID: 0,
        productGroupID: this.productGroup.productGroupID,
        productCategoryID:
          this.categories.length > 0
            ? this.categories[0].productCategoryID
            : null,
        productName: "",
        productImg: "",
        productDetail: "",
        productPrice: null,
        isRecommend: false,
        isActive: true,
        // Chinese fields
        productNameCN: "",
        productImgCN: "",
        productDetailCN: "",
        // English fields
        productNameEN: "",
        productImgEN: "",
        productDetailEN: "",
      };
      this.imagePreview = null;
      this.productImage = null;
      this.imagePreviewCN = null;
      this.productImageCN = null;
      this.imagePreviewEN = null;
      this.productImageEN = null;
      this.productDialog = true;
    },

    editProduct(index) {
      let filterProductsTemp =
        this.filteredProductsList.length == 0
          ? this.products
          : this.filteredProductsList;
      this.editingIndex = index;
      this.currentLanguageTab = 0;
      this.currentProduct = { ...filterProductsTemp[index] };
      this.imagePreview = filterProductsTemp[index].productImg;
      this.imagePreviewCN = filterProductsTemp[index].productImgCN;
      this.imagePreviewEN = filterProductsTemp[index].productImgEN;
      this.productDialog = true;
    },

    closeProductDialog() {
      this.productDialog = false;
      this.currentLanguageTab = 0;
    },
    filterProducts() {
      // Apply filters only if at least one filter is set
      const hasProductNameFilter =
        this.searchProductName && this.searchProductName.trim() !== "";
      const hasCategoryFilter =
        this.searchCategory !== null && this.searchCategory !== undefined;

      if (!hasProductNameFilter && !hasCategoryFilter) {
        this.filteredProductsList = [];
        return;
      }

      this.filteredProductsList = this.products.filter((product) => {
        let matchesProductName = true;
        let matchesCategory = true;

        // Apply product name filter if set
        if (hasProductNameFilter) {
          const productNameLower = product.productName.toLowerCase();
          const searchTermLower = this.searchProductName.toLowerCase();
          matchesProductName = productNameLower.includes(searchTermLower);
        }

        // Apply category filter if set
        if (hasCategoryFilter) {
          matchesCategory = product.productCategoryID === this.searchCategory;
        }

        // Return true only if all applied filters match
        return matchesProductName && matchesCategory;
      });
    },

    // Add a method to clear all filters
    clearFilters() {
      this.searchProductName = "";
      this.searchCategory = null;
      this.filteredProductsList = [];
    },
    deleteProduct(id, index) {
      let self = this;
      this.deleteIndex = index;
      try {
        self.$swal
          .fire({
            title: "Delete Product",
            text: "Are you sure you want to delete this product? This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.DeleteProduct(
                {
                  ProductID: id,
                  ProductGroupID: self.productGroup.productGroupID,
                },
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    if (this.deleteIndex > -1) {
                      // this.products.splice(this.deleteIndex, 1);
                      // this.deleteIndex = -1;
                      const prodIdx = this.products.findIndex(p => p.productID === id);
                      if (prodIdx > -1) {
                        this.products.splice(prodIdx, 1);
                      }
                      this.deleteIndex = -1;
                      this.showSuccessMessage("Product deleted successfully");

                      // After delete, reapply filters if any are active
                      if (
                        this.searchProductName ||
                        this.searchCategory !== null
                      ) {
                        this.filterProducts();
                      }
                    }
                  }else if (dataResponse.status == 1) {
                    self.$swal.fire({
                      icon: "error",
                      title: dataResponse.message,
                      showConfirmButton: true,
                      confirmButtonText: this.$t("gotIt"),
                      confirmButtonColor: "#d33",
                    });
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    ReprocessVectorProduct() {
      let self = this;
      try {
        self.$swal
          .fire({
            title: "Reprocess Product",
            text: "Are you sure you want to reprocess this product group? This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.ReprocessVectorProduct(
                { ProductGroupID: self.productGroup.productGroupID },
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.showSuccessMessage("Product reprocess successfully");
                    self.needsReprocessing = false;
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },

    // Image handling
    clearImage(lang = 'th') {
      if (lang === 'th') {
        this.productImage = null;
        this.imagePreview = null;
        this.currentProduct.productImg = "";
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = null;
        }
      } else if (lang === 'cn') {
        this.productImageCN = null;
        this.imagePreviewCN = null;
        this.currentProduct.productImgCN = "";
        if (this.$refs.fileInputCN) {
          this.$refs.fileInputCN.value = null;
        }
      } else if (lang === 'en') {
        this.productImageEN = null;
        this.imagePreviewEN = null;
        this.currentProduct.productImgEN = "";
        if (this.$refs.fileInputEN) {
          this.$refs.fileInputEN.value = null;
        }
      }
    },
    
    handleImageUpload(file, lang = 'th') {
      if (!file) {
        if (lang === 'th') {
          this.productImage = null;
        } else if (lang === 'cn') {
          this.productImageCN = null;
        } else if (lang === 'en') {
          this.productImageEN = null;
        }
        return;
      }

      const imageUrl = URL.createObjectURL(file);

      if (lang === 'th') {
        this.imagePreview = imageUrl;
        this.currentProduct.productImg = imageUrl;
        this.productImage = file;
      } else if (lang === 'cn') {
        this.imagePreviewCN = imageUrl;
        this.currentProduct.productImgCN = imageUrl;
        this.productImageCN = file;
      } else if (lang === 'en') {
        this.imagePreviewEN = imageUrl;
        this.currentProduct.productImgEN = imageUrl;
        this.productImageEN = file;
      }
    },

    showSuccessMessage(message) {
      this.$swal.fire({
        icon: "success",
        title: "Success",
        text: message,
        timer: 1500,
        showConfirmButton: false,
      });
    },
    getProductGroupData() {
      var self = this;
      self.dialog = true;
      this.$call.GetProductDetailById(
        this.id,
        (dataResponse) => {
          if (dataResponse.status === 0) {
            self.productGroup = {
              productGroupID: dataResponse.data.productGroupID,
              productGroupName: dataResponse.data.productGroupName,
            };
            self.originalProductGroupName = dataResponse.data.productGroupName;
            self.categories = dataResponse.data.productCategories;
            self.products = dataResponse.data.products;
            self.needsReprocessing = dataResponse.data.needsReprocessing;
          }
          self.dialog = false;
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },

    // Save product
    saveProduct(product) {
      const self = this;
      if (
        !this.productGroup.productGroupName ||
        this.productGroup.productGroupName.trim() === ""
      ) {
        this.productGroupNameTouched = true;
        this.$swal.fire({
          icon: "warning",
          title: "Product Group Name Required",
          text: "Please enter a Product Group Name before saving.",
          confirmButtonColor: "#3085d6",
        });
        return;
      }
      if (!product.productName || product.productName.trim() === "") {
        this.$swal.fire({
          icon: "warning",
          title: "Product Name Required",
          text: "Please enter a Product Name before saving.",
          confirmButtonColor: "#3085d6",
        });
        return;
      }
      if (!product.productDetail || product.productDetail.trim() === "") {
        this.$swal.fire({
          icon: "warning",
          title: "Product detail Required",
          text: "Please enter a Product detail before saving.",
          confirmButtonColor: "#3085d6",
        });
        return;
      }
      // สร้าง FormData สำหรับส่งไฟล์และข้อมูล
      const formData = new FormData();

      // เพิ่มไฟล์รูปภาพ (ถ้ามี)
      if (this.productImage) {
        formData.append("productImage", this.productImage);
      }
      if (this.productImageCN) {
        formData.append("productImageCN", this.productImageCN);
      }
      if (this.productImageEN) {
        formData.append("productImageEN", this.productImageEN);
      }

      const payload = {
        productGroupID: this.productGroup.productGroupID,
        productGroupName: this.productGroup.productGroupName,
        productID: product.productID || null,
        productCategoryID: product.productCategoryID || 0,
        productName: product.productName,
        productDetail: product.productDetail || "",
        productPrice: product.productPrice || 0,
        productImg: product.productImg,
        isRecommend: product.isRecommend,
        isActive: product.isActive,
        activeFlag: true,
        // Chinese fields
        productNameCN: product.productNameCN || "",
        productDetailCN: product.productDetailCN || "",
        productImgCN: product.productImgCN || "",
        // English fields
        productNameEN: product.productNameEN || "",
        productDetailEN: product.productDetailEN || "",
        productImgEN: product.productImgEN || "",
      };

      // แปลง object เป็น JSON และเพิ่มลงใน FormData
      formData.append("productData", JSON.stringify(payload));
      this.dialog = true;
      this.$call.CreateProduct(
        formData,
        (dataResponse) => {
          if (dataResponse.status === 0) {
            self.productGroup.productGroupID = dataResponse.data.productGroupID;
            self.products = dataResponse.data.product;

            // Update URL with the product group ID if it's a new product group
            if (self.id === null || self.id === undefined) {
              // Update browser URL without reloading the page
              const newUrl = `${window.location.pathname}?id=${self.productGroup.productGroupID}`;
              history.pushState({ path: newUrl }, "", newUrl);

              // Update the component's id property
              self.id = self.productGroup.productGroupID;
            }

            this.closeProductDialog();
            this.showSuccessMessage(
              this.editingIndex === -1
                ? "Product added successfully"
                : "Product updated successfully"
            );

            // After save, reapply filters if any are active
            if (this.searchProductName || this.searchCategory !== null) {
              this.filterProducts();
            }
          }else if (dataResponse.status === 3) {
            this.categories = this.categories.filter(
                (item) => item.productCategoryID !== null
              );
            self.$swal.fire({
              icon: "warning",
              title:dataResponse.message,
              // title: "Duplicate Product",
              // text: dataResponse.message,
              confirmButtonColor: "#3085d6",
            });
          }
          self.dialog = false;
          self.clearImage('th');
          self.clearImage('cn');
          self.clearImage('en');
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },

    // Save category
    saveCategory() {
      const self = this;
      // First validate the product group name
      if (
        !this.productGroup.productGroupName ||
        this.productGroup.productGroupName.trim() === ""
      ) {
        this.productGroupNameTouched = true;
        this.$swal.fire({
          icon: "warning",
          title: "Product Group Name Required",
          text: "Please enter a Product Group Name before saving.",
          confirmButtonColor: "#3085d6",
        });
        return;
      }

      const payload = {
        productGroupID: this.productGroup.productGroupID,
        productGroupName: this.productGroup.productGroupName,
        categories: this.categories,
      };

      this.dialog = true;

      this.$call.CreateCategory(
        payload,
        (dataResponse) => {
          if (dataResponse.status === 0) {
            self.productGroup.productGroupID = dataResponse.data.productGroupID;
            self.categories = dataResponse.data.categories;

            // Update URL with the product group ID if it's a new product group
            if (self.id === null || self.id === undefined) {
              // Update browser URL without reloading the page
              const newUrl = `${window.location.pathname}?id=${self.productGroup.productGroupID}`;
              history.pushState({ path: newUrl }, "", newUrl);

              // Update the component's id property
              self.id = self.productGroup.productGroupID;
            }

            this.showSuccessMessage("All data saved successfully");
          }else if (dataResponse.status === 3) {
            this.categories = this.categories.filter(
              (item) => item.productCategoryID !== null
            );
            self.$swal.fire({
              icon: "warning",
              title: dataResponse.message,
              // text: dataResponse.message,
              confirmButtonColor: "#3085d6",
            })
          }
          self.categoryDialog = false;
          // Clear the new category input field
          self.newCategory = "";
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },

    // Add these methods to your existing methods
    openCategoryDialog() {
      // เก็บสำเนาของ categories ไว้เปรียบเทียบการเปลี่ยนแปลง
      this.originalCategories = JSON.parse(JSON.stringify(this.categories));
      this.categoryDialog = true;
    },

    closeCategoryDialog() {
      // ถ้ามีการเปลี่ยนแปลงและผู้ใช้ยังไม่ได้บันทึก ให้แสดงการยืนยัน
      if (this.isCategoryChanged) {
        this.$swal
          .fire({
            title: "Unsaved Changes",
            text: "You have unsaved changes. Are you sure you want to close without saving?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, close",
            cancelButtonText: "No, keep editing",
            confirmButtonColor: "#3085d6",
          })
          .then((result) => {
            if (result.isConfirmed) {
              // ถ้าผู้ใช้ยืนยันที่จะปิด ให้คืนค่า categories กลับเป็นค่าเดิม
              this.categories = JSON.parse(
                JSON.stringify(this.originalCategories)
              );
              this.categoryDialog = false;
              this.editingCategoryIndex = -1;
              this.editedCategoryName = "";
              this.newCategory = "";
            }
          });
      } else {
        // ถ้าไม่มีการเปลี่ยนแปลง ให้ปิดได้เลย
        this.categoryDialog = false;
        this.editingCategoryIndex = -1;
        this.editedCategoryName = "";
        this.newCategory = "";
      }
    },
    formatProductPrice() {
      // Allow empty value
      if (
        this.currentProduct.productPrice === null ||
        this.currentProduct.productPrice === ""
      ) {
        return;
      }

      // Convert to string and validate format
      let priceStr = this.currentProduct.productPrice.toString();

      // Ensure positive number - should no longer be needed due to keydown prevention
      // but keeping as a safeguard
      if (parseFloat(priceStr) < 0) {
        this.currentProduct.productPrice = 0;
        return;
      }

      // If more than 2 decimal places, truncate to 2
      if (priceStr.includes(".")) {
        const parts = priceStr.split(".");
        if (parts[1] && parts[1].length > 2) {
          // Truncate to 2 decimal places
          this.currentProduct.productPrice = parseFloat(
            parts[0] + "." + parts[1].substring(0, 2)
          );
        }
      }
    },
    preventInvalidPriceInput(e) {
      // Prevent minus sign
      if (e.key === "-") {
        e.preventDefault();
        return;
      }

      // Prevent more than 2 decimal places
      if (
        e.key !== "Backspace" &&
        e.key !== "Delete" &&
        e.key !== "Tab" &&
        e.key !== "ArrowLeft" &&
        e.key !== "ArrowRight"
      ) {
        const value = e.target.value;
        if (value.includes(".")) {
          const parts = value.split(".");
          if (parts[1] && parts[1].length > 1) {
            // Get cursor position
            e.preventDefault();
            return;
          }
        }
      }
    },
  },
  async mounted() {
    let self = this;
    self.GetDate();
    if (self.$route.query.id) {
      self.id = this.$route.query.id;
      this.getProductGroupData(self.id);
    } else {
      // Initialize as a new product group
      self.id = null;
      self.productGroup = {
        productGroupID: null,
        productGroupName: "",
      };
      self.categories = [];
      self.products = [];
    }
  },
};
</script>
<style scoped>
.content-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  gap: 2rem;
  display: flex;
  flex-direction: column;
}

/* Header Section */
.modern-header {
  width: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 1.5rem 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.header-icon {
  color: rgba(0, 0, 0, 0.753) !important;
}

.date-chip {
  background: rgba(255, 255, 255, 0.2) !important;
  color: white !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
}

/* Modern Cards */
.modern-card {
  background: white;
  border-radius: 16px !important;
  border: 1px solid rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.modern-card:hover {
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1) !important;
  transform: translateY(-2px);
}

/* Card Headers */
.card-header,
.products-header {
  display: flex;
  align-items: center;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
  border-radius: 16px 16px 0 0;
}

.products-header {
  justify-content: space-between;
}

.products-header-left,
.products-header-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.card-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #2c3e50;
  margin-left: 0.5rem;
}

.card-content {
  padding: 2rem;
}
/* Minimal Input Styles */
.minimal-field {
  margin-bottom: 8px;
}

.minimal-field :deep(.v-field) {
  background: #fafafa;
  border-radius: 8px !important;
  box-shadow: none !important;
  --v-field-outline-width: 1px !important;
  --v-field-outline-color: #e0e0e0 !important;
}

.minimal-field :deep(.v-field--focused) {
  --v-field-outline-width: 2px !important;
  --v-field-outline-color: #667eea !important;
  background: white;
}

.minimal-field :deep(.v-field--error) {
  --v-field-outline-color: #f44336 !important;
}

.minimal-field :deep(.v-field__input) {
  padding: 10px 12px !important;
  font-size: 14px !important;
  min-height: 40px !important;
}

.minimal-field :deep(.v-field__prepend-inner) {
  padding-left: 8px !important;
}

.minimal-field :deep(.v-field__prepend-inner .v-icon) {
  opacity: 0.5 !important;
  font-size: 18px !important;
}

.minimal-field :deep(.v-label) {
  font-size: 13px !important;
  color: #666 !important;
  opacity: 0.8 !important;
}

.minimal-field :deep(.v-field--focused .v-label) {
  color: #667eea !important;
  opacity: 1 !important;
}

.minimal-field :deep(.v-field__outline) {
  border-radius: 8px !important;
}

.minimal-field :deep(.v-messages) {
  font-size: 12px !important;
  padding-top: 4px !important;
}

/* Modern Buttons */
.modern-btn {
  text-transform: none !important;
  font-weight: 500 !important;
  border-radius: 12px !important;
  padding: 8px 20px !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

.modern-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15) !important;
}

.reprocess-btn {
  background: linear-gradient(135deg, #9747ff 0%, #7c3aed 100%) !important;
  color: white !important;
  position: relative;
}

.action-btn {
  text-transform: none !important;
  border-radius: 8px !important;
  font-weight: 500 !important;
  flex: 1;
}

.action-btn-dialog {
  text-transform: none !important;
  font-weight: 500 !important;
  border-radius: 8px !important;
  padding: 8px 24px !important;
}

/* Search & Filter Section */
.search-section {
  padding: 1.5rem 2rem 0 2rem !important;
}

.modern-search,
.modern-select {
  border-radius: 12px;
}

.filter-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  padding: 1rem 0;
}

.result-chip {
  font-weight: 500;
}

.clear-filter-btn {
  text-transform: none !important;
  border-radius: 8px !important;
}

/* Products Grid */
.products-grid {
  padding: 0.75rem 1.5rem 1.5rem 1.5rem !important;
}

.products-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 0.75rem;
}

/* Product Cards - ขนาดเล็กลง */
.product-card-modern {
  border-radius: 8px !important;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.product-card-modern:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1) !important;
}

.product-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.product-image-container {
  position: relative;
  overflow: hidden;
}

.product-image-modern {
  transition: transform 0.3s ease;
}

.product-card-modern:hover .product-image-modern {
  transform: scale(1.02);
}

.image-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120px;
  background: #f5f5f5;
}

.product-content {
  padding: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex-grow: 1;
}

.product-header-info {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.5rem;
}

.product-name {
  min-height: 35px;
  font-size: 0.875rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  line-height: 1.2;
  flex-grow: 1;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.product-price {
  font-size: 0.875rem;
  font-weight: 700;
  color: #667eea;
  white-space: nowrap;
}

.product-category {
  margin: 0;
}

.language-indicators {
  display: flex;
  gap: 0.25rem;
  flex-wrap: wrap;
  margin: 0;
}

.lang-chip {
  font-size: 0.6rem !important;
  height: 18px !important;
  padding: 0 4px !important;
}

.lang-chip .v-icon {
  margin-right: 2px !important;
}

.product-description-modern {
  color: #6c757d;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0;
  flex-grow: 1;
  font-size: 0.75rem;
}

.product-status {
  display: flex;
  gap: 0.25rem;
  flex-wrap: wrap;
}

.status-chip {
  font-size: 0.65rem !important;
}

.product-actions {
  display: flex;
  gap: 0.25rem;
  margin-top: auto;
  padding-top: 0.25rem;
}

.action-btn {
  text-transform: none !important;
  border-radius: 4px !important;
  font-weight: 500 !important;
  flex: 1;
  font-size: 0.7rem !important;
  padding: 4px 8px !important;
  min-height: 24px !important;
}

/* Empty States - ลดขนาด */
.empty-state {
  text-align: center;
  padding: 2rem 1rem;
  color: #6c757d;
}

.empty-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0.75rem 0 0.25rem 0;
  color: #495057;
}

.empty-subtitle {
  font-size: 0.875rem;
  margin: 0;
}

/* Dialog Styles */
/* .modern-dialog {
  z-index: 1000;
}

.modern-dialog-card {
  border-radius: 20px !important;
  overflow: hidden;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
  border-bottom: 1px solid rgba(0,0,0,0.08);
}

.dialog-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  display: flex;
  align-items: center;
}

.close-btn {
  color: #6c757d !important;
}

.dialog-content {
  padding: 2rem !important;
}

.dialog-actions {
  padding: 1.5rem 2rem !important;
  background: #f8f9fa;
  border-top: 1px solid rgba(0,0,0,0.08);
} */

/* Image Upload */
.image-upload-modern {
  width: 100%;
}

.upload-btn-modern {
  text-transform: none !important;
  border-radius: 12px !important;
  font-weight: 500 !important;
  transition: all 0.3s ease !important;
}

.selected-file-modern {
  display: flex;
  align-items: center;
  margin-top: 1rem;
  padding: 0.75rem;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.file-name {
  flex-grow: 1;
  font-size: 0.875rem;
  color: #495057;
  font-weight: 500;
}

/* Switches */
.switches-container {
  display: flex;
  align-items: center;
  height: 56px;
}

.modern-switch {
  margin: 0 !important;
  transform: scale(0.9);
}

/* Language Tabs */
.language-tabs {
  border-bottom: 2px solid #e0e0e0;
  margin-bottom: 1.5rem !important;
}

.language-tab {
  display: flex;
  align-items: center;
  text-transform: none !important;
  font-weight: 500 !important;
  font-size: 0.95rem !important;
  letter-spacing: 0.3px !important;
  padding: 12px 24px !important;
  transition: all 0.3s ease !important;
}

.language-tab:hover {
  background: rgba(102, 126, 234, 0.08) !important;
}

.flag-emoji {
  font-size: 18px;
  font-weight: 600;
  margin-right: 8px;
}

.v-window {
  overflow: visible !important;
}

.v-window-item {
  padding-top: 0.5rem;
}

/* Image Preview */
.image-preview-container {
  margin-top: 1rem;
}

.preview-title {
  font-size: 1rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 1rem;
}

.preview-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.preview-image {
  background: #f8f9fa;
}

/* Category Management */
.add-category-section {
  margin-bottom: 1rem;
}

.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
}

.empty-categories {
  text-align: center;
  padding: 3rem 1rem;
  color: #6c757d;
}

.empty-text {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 1rem 0 0.5rem 0;
  color: #495057;
}

.empty-subtext {
  font-size: 0.9rem;
  margin: 0;
}

.categories-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.category-item {
  border-radius: 12px !important;
  border: 1px solid rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.category-item:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1) !important;
}

.category-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
}

.category-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-grow: 1;
}

.category-icon {
  opacity: 0.7;
}

.category-name {
  font-size: 1rem;
  font-weight: 500;
  color: #2c3e50;
}

.edit-input {
  max-width: 200px;
}

.category-actions {
  display: flex;
  gap: 0.25rem;
}

/* Loading Overlay */
/* .loading-card {
  background: white;
  border-radius: 16px !important;
  padding: 2rem;
  text-align: center;
  min-width: 300px;
}

.loading-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 0.5rem 0;
}

.loading-subtitle {
  color: #6c757d;
  margin: 0;
} */

/* Notification Badge */
.notification-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: #ff4757;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 12px;
  box-shadow: 0 2px 8px rgba(255, 71, 87, 0.4);
  border: 2px solid white;
  animation: pulse 2s infinite;
}

/* Dialog Styles */
.modern-dialog {
  z-index: 1000;
}

.dialog-card {
  border-radius: 16px !important;
  overflow: hidden;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.dialog-header-add {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.header-main {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.header-icon-container {
  display: flex;
  align-items: center;
}

.icon-background {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  backdrop-filter: blur(10px);
}

.header-text-content {
  display: flex;
  flex-direction: column;
}

.dialog-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  color: white;
}

.header-actions {
  display: flex;
  align-items: center;
}

.close-button {
  background: rgba(255, 255, 255, 0.2) !important;
  backdrop-filter: blur(10px);
}

.close-button:hover {
  background: rgba(255, 255, 255, 0.3) !important;
}

.dialog-content {
  padding: 2rem !important;
  max-height: 70vh;
  overflow-y: auto;
}

.dialog-actions {
  padding: 1.5rem 2rem !important;
  background: #f8f9fa;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.actions-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.actions-left {
  display: flex;
  gap: 0.5rem;
}

.actions-right {
  display: flex;
  gap: 0.75rem;
}

.dialog-action-btn {
  text-transform: none !important;
  font-weight: 500 !important;
  border-radius: 8px !important;
  padding: 8px 24px !important;
  min-width: 100px !important;
}

.cancel-btn {
  border-color: #dee2e6 !important;
  color: #6c757d !important;
}

.save-btn-add {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3) !important;
}

.save-btn-add:hover:not(:disabled) {
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4) !important;
  transform: translateY(-1px);
}

.save-btn-add:disabled {
  opacity: 0.5 !important;
  background: #ccc !important;
  box-shadow: none !important;
}

/* Loading Card */
.loading-card {
  background: white;
  border-radius: 16px !important;
  padding: 2rem;
  text-align: center;
  min-width: 300px;
}

.loading-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 0.5rem 0;
}

.loading-subtitle {
  color: #6c757d;
  margin: 0;
}

/* Animations */
@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 71, 87, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 8px rgba(255, 71, 87, 0);
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 71, 87, 0);
  }
}

/* Focus and Accessibility */
.modern-btn:focus,
.action-btn:focus,
.action-btn-dialog:focus {
  outline: 2px solid #667eea;
  outline-offset: 2px;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .products-list {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  }
}

@media (max-width: 768px) {
  .content-wrapper {
    padding: 1rem;
    gap: 1rem;
  }

  .products-header {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }

  .products-header-right {
    justify-content: space-between;
  }

  .modern-btn {
    flex: 1;
    min-width: 0;
  }

  .products-list {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 0.75rem;
  }

  .products-grid {
    padding: 1rem !important;
  }

  .product-content {
    padding: 0.75rem;
  }
  .product-header-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .header-content {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }

  .dialog-content {
    padding: 1rem !important;
  }
}

@media (max-width: 480px) {
  .products-list {
    grid-template-columns: 1fr;
  }

  .product-header-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  .modern-header {
    padding: 1rem;
  }

  .header-title {
    font-size: 1.5rem;
  }

  .products-header-right {
    flex-direction: column;
    gap: 0.5rem;
  }

  .card-header,
  .products-header {
    padding: 1rem;
  }

  .card-content,
  .search-section,
  .products-grid {
    padding: 1rem !important;
  }
}

.delet-btn:disabled {
  border: 1px solid #dd00004d !important;
  color: #dd000085 !important;
}

.delet-btn:disabled :deep(.v-icon) {
  color: #dd00007b !important;
  opacity: 1 !important;
}
</style>
